import script from "./homepage.vue?vue&type=script&setup=true&lang=js"
export * from "./homepage.vue?vue&type=script&setup=true&lang=js"

import "./homepage.vue?vue&type=style&index=0&id=516ff525&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-516ff525"]])

export default __exports__